<template>
  <div class="menber_box">
    <div class="menber_box_img">
      <img style="width:100%" :src="serve + '/bannerAD/footAD/advance/member1.jpg'" alt />
      <img style="width:100%" :src="serve + '/bannerAD/footAD/advance/member2.jpg'" alt />
      <img style="width:100%" :src="serve + '/bannerAD/footAD/advance/member3.jpg'" alt />
      <img style="width:100%" :src="serve + '/bannerAD/footAD/advance/member4.jpg'" alt />
      <img style="width:100%" :src="serve + '/bannerAD/footAD/advance/member5.jpg'" alt />
      <img style="width:100%" :src="serve + '/bannerAD/footAD/advance/member6.jpg'" alt />
      <img style="width:100%" :src="serve + '/bannerAD/footAD/advance/member7.jpg'" alt />
      <img style="width:100%" :src="serve + '/bannerAD/footAD/advance/member8.jpg'" alt />
      <div class="member_div">
          <img style="width:100%" :src="serve + '/bannerAD/footAD/advance/member9.jpg'" alt />
          <router-link to="/user/bargain/2">
            <img class="menber_btn"  :src="serve + '/bannerAD/footAD/advance/member_btn.png'" alt />
         </router-link>
      </div>
      <img style="width:100%" :src="serve+'/bannerAD/footAD/advance/member10.jpg'" alt />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
    };
  }
};
</script>

<style lang='scss'>
.menber_box{
   width: 1200px;
   margin:  0 auto;
   .member_div{
      position: relative;
      .menber_btn{
         width: 50%;
         position: absolute;
         left:300px;
         top: 0;
         cursor: pointer;
      }
   }
}
</style>